import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ActivityTime: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID } = props;

    return (
        <BodyText className={`${className} ${styles.activityTime}`} testId={testId}>
            {children}
        </BodyText>
    );
};

export default ActivityTime;
